import { render, staticRenderFns } from "./NsProductQuantitySelector.vue?vue&type=template&id=610f9874&scoped=true&"
import script from "./NsProductQuantitySelector.vue?vue&type=script&lang=js&"
export * from "./NsProductQuantitySelector.vue?vue&type=script&lang=js&"
import style0 from "./NsProductQuantitySelector.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./NsProductQuantitySelector.vue?vue&type=style&index=1&id=610f9874&lang=scss&scoped=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsProductQuantitySelector.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./NsProductQuantitySelector.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("610f9874")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "610f9874",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610f9874')) {
      api.createRecord('610f9874', component.options)
    } else {
      api.reload('610f9874', component.options)
    }
    module.hot.accept("./NsProductQuantitySelector.vue?vue&type=template&id=610f9874&scoped=true&", function () {
      api.rerender('610f9874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductQuantitySelector.vue"
export default component.exports